module.exports = __webpack_public_path__ + "static/media/reg3.b6be762f.jpg";